module.exports = __webpack_public_path__ + "img/2.e165fdf6.png";